import velocity from 'velocity-animate';

export default class Hamburger {
  constructor() {
    this.gnav = document.getElementById('Gnav');
    this.gnavItem = document.getElementsByClassName('gnav__item');
    this.hamBtn = document.getElementById('HamburgerBtn');
    this.clickEvent();
  }

  clickEvent() {
    let _this = this;
    this.hamBtn.addEventListener('click', function() {
      if (this.classList.contains('is-click-on')) {
        _this.onDisplay();
      } else {
        _this.offDisplay();
      }
    });
  }

  onDisplay() {
    this.gnav.style.display = 'block';
    Velocity(this.gnav,
      {
        opacity: '1'
      },
      {
        duration: 400,
        ease: 'easeOutExpo',
        // ,
        // complete: () => {
        //   for(let i = 0; i < gnvItem.length; i++) {
        //     Velocity(gnvItem[i],
        //       {
        //         opacity: 1
        //       },
        //       {
        //         duration: 400,
        //         delay: 300
        //       }
        //     );
        //   }
        // }
      }
    );
  }

  offDisplay() {
    Velocity(this.gnav,
          {
            opacity: "0"
          },
          {
            duration: 600,
            ease: 'easeOutExpo',
            complete: () =>{
              // for(let i = 0; i < gnvItem.length; i++) {
              //   Velocity(gnvItem[i],
              //     {
              //       opacity: 0
              //     },
              //     {
              //       duration: 100
              //     }
              //   );
              // }
              this.gnav.style.display = 'none';
            }
          }
        );
  }

}



// WEBPACK FOOTER //
// ./src/assets/js/components/Hamburger.js